export default function StatCard({ icon: Icon, label, value, detail }) {
  return <section className="stat-card">{Icon && <Icon size={22} />}<div><span>{label}</span><strong>{value}</strong>{detail && <small>{detail}</small>}</div></section>;
}
